export const saveRevisionJson = {
	id:"",
	revision:{} ,
	saveProperties: {
	  FilesToCopy: [],
	  CopyFilesFromLatest: false
	}
  }

export const NewRevisionJson = {
	RevSeqno:-1,
	DocRno:-1,
	DbRno:-1,
	RevRno:-1,
	Rno:-1,
	RevisionCode: "",
	Status: "",
	MetaItems: [{Name: "STATUS", Value: "", HasMultipleValues: false}],
	TypeName:"SI.ProArc.WS.Revisions.Revision"
}

export const getRevisionsJson = {
    "docRno": 0
  }